import { ICompte, ICompteActeursJuridiquesReturn, ICompteAlerteParution, ICompteChangeEmailReturn, ICompteChangeLogin, ICompteChangeLoginEnvoiMail, ICompteMarquesReturn, ICompteReturn, ICompteUpdateActeursJuridiques, ICompteUpdateMarques, ICompteUpdateModules, IComptesReturn } from '../../../../models/interfaces/ICompte';
import { ServiceApplication_Key } from "../../../../config/helpers";
import { ICompteStatusReturn } from "../../../../models/interfaces/ICompteStatus";
import { apiSlice } from "../../api";
import { IFilterCompteDTO } from '../../../../models/interfaces/IFilterCompte';
import { IChangePasswordReturn, IPasswordReset } from '../../../../models/interfaces/IPassword';
import { ILoginReturn } from '../../../../models/interfaces/ILoginReturn';
import { ICompteCheckActif } from '../../../../models/interfaces/ICompteCheckActif';


export interface compteApiQueryBody {
  Application_Key: string;
  // eslint-disable-next-line
  Values: any;
}

export interface ICompteLoginExistParams {
  Login: string;
  IdDemande?: number | null;
  IdCompte?: number | null;
  Inscription?: boolean;
}

export const compteApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    compteLoginExist: builder.query<ICompteStatusReturn, ICompteLoginExistParams>({
      query: (params) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {
            Login: params.Login,
            IdDemande: params.IdDemande,
            IdCompte: params.IdCompte,
            Inscription: params.Inscription ?? false
          },
        };
        return {
          url: "/Compte/Compte_LoginExist",
          method: "POST",
          body: body,
        };
      },
      transformResponse: (response: ICompteStatusReturn ,meta, arg) => {
        // Ajouter Login à la réponse
        return {
          ...response,
          userName: arg.Login,
        };
      },
    }),
    fetchCompte: builder.query<ICompteReturn, string>({
      query: (Id: string) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values:{ Id: Id },
        };

        return {
          url: "/Compte/Compte_Get",
          method: "POST",
          body: body,
        };
      },
    }),
   fetchComptes: builder.query<IComptesReturn, IFilterCompteDTO|undefined>({
      query: (obj) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: obj,
        };

        return {
          url: "/Compte/Compte_GetAll",
          method: "POST",
          body: body,
        };
      },
    }),
    updateCompte: builder.mutation<ICompteReturn, ICompte>({
      query: (data) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/Compte/Compte_Update",
          method: "POST",
          body: body,
        };
      },
    }),
    updateCompteAlerteParution: builder.mutation<ICompteReturn, ICompteAlerteParution>({
      query: (data) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/Compte/Compte_AlerteParution_Update",
          method: "POST",
          body: body,
        };
      },
      // transformErrorResponse: (response) => {
        
      //   if (response.status === "FETCH_ERROR") {
      //     // Erreur réseau (serveur inaccessible)
      //     return { error:"Le serveur est inaccessible. Vérifiez votre connexion réseau."};
      //   }
      //   if (response.status === "TIMEOUT_ERROR") {
      //     // Erreur de timeout
      //     return { message: "La requête a expiré. Veuillez réessayer plus tard." };
      //   }
      //   if (response.data) {
      //     // Gestion des erreurs renvoyées par le backend
      //     return { message: "Une erreur est survenue côté serveur." }; //response.data.errorMessage ||
      //   }
      //   // Gestion des cas non couverts
      //   return { message: "Erreur inconnue. Veuillez réessayer." };
      // },
    }),
    compteLoginCreate: builder.mutation<ICompteReturn, ICompte>({
      query: (data) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/Compte/Compte_LoginCreate",
          method: "POST",
          body: body,
        };
      },
    }),
    fetchCompteLoginActif: builder.query<ILoginReturn, ICompteCheckActif>({
      query: (data) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/Compte/Compte_LoginActif",
          method: "POST",
          body: body,
        };
      },
    }),
    compteLoginConfirmation: builder.mutation<ILoginReturn, IPasswordReset>({
      query: (data) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/Compte/Compte_LoginConfirmation",
          method: "POST",
          body: body,
        };
      },
    }),
    compteChangeLoginEmail: builder.mutation<ILoginReturn, ICompteChangeLogin>({
      query: (data) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {Code: data.Code,NewLogin: data.NewLogin},
        };
        return {
          url: "/Compte/Compte_ChangeLoginConfirmation",
          method: "POST",
          body: body,
        };
      },
    }),
    compteChangeLoginEnvoiMail: builder.mutation<ICompteChangeEmailReturn, ICompteChangeLoginEnvoiMail>({
      query: (data) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {Login : data.Login, NewLogin: data.NewLogin},
        };
        return {
          url: "/Compte/Compte_ChangeLoginEmail_EnvoiMail",
          method: "POST",
          body: body,
        };
      },
    }),
    updatePassword: builder.mutation<IChangePasswordReturn, IPasswordReset>({
      query: (data) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/Compte/Compte_ChangePassword",
          method: "POST",
          body: body,
        };
      },
    }),
    fetchCompteGetAllMarques: builder.query<ICompteMarquesReturn, number|undefined>({
      query: (Id?: number) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values:{ Id: Id },
        };
       return {
          url: "/Compte/Compte_Get_AllMarques",
          method: "POST",
          body: body,
        };
      },
    }),
    fetchCompteGetMarques: builder.query<ICompteMarquesReturn, number|undefined>({
      query: (Id?: number) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values:{ Id: Id },
        };
       return {
          url: "/Compte/Compte_Get_Marques",
          method: "POST",
          body: body,
        };
      },
    }),
    fetchCompteGetActeursJuridiques: builder.query<ICompteActeursJuridiquesReturn, number|undefined>({
      query: (Id?: number) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values:{ Id: Id },
        };
       return {
          url: "/Compte/Compte_Get_ActeursJuridiques",
          method: "POST",
          body: body,
        };
      },
    }),
    CompteUpdateMarques: builder.mutation<ICompteMarquesReturn, ICompteUpdateMarques >({ //IMarquesListUpdate
      query: (data) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/Compte/Compte_Update_Marques",
          method: "POST",
          body: body,
        };
      },
    }),
    CompteUpdateActeursJuridiques: builder.mutation<ICompteActeursJuridiquesReturn, ICompteUpdateActeursJuridiques>({
      query: (data) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/Compte/Compte_Update_ActeursJuridiques",
          method: "POST",
          body: body,
        };
      },
    }),
    // CompteUpdateAllMarques: builder.mutation<ICompteMarquesReturn, IMarquesListUpdate>({
    //   query: (data) => {
    //     const body: compteApiQueryBody = {
    //       Application_Key: ServiceApplication_Key,
    //       Values: data,
    //     };
    //     return {
    //       url: "/Compte/Compte_Update_AllMarques",
    //       method: "POST",
    //       body: body,
    //     };
    //   },
    // }),

    
    UpdateCompteModules: builder.mutation<ICompteReturn, ICompteUpdateModules>({
      query: (data:ICompteUpdateModules) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/Compte/Compte_UpdateModules",
          method: "POST",
          body: body,
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyCompteLoginExistQuery,
  useLazyFetchComptesQuery,
  useFetchComptesQuery,
  useFetchCompteQuery,
  useUpdateCompteMutation,
  useUpdateCompteAlerteParutionMutation,
  useCompteLoginCreateMutation,
  useCompteLoginConfirmationMutation,
  useFetchCompteLoginActifQuery,
  useCompteChangeLoginEmailMutation,
  useCompteChangeLoginEnvoiMailMutation,
  useUpdatePasswordMutation,
  useFetchCompteGetAllMarquesQuery,
  useFetchCompteGetMarquesQuery,
  useFetchCompteGetActeursJuridiquesQuery,
  useCompteUpdateMarquesMutation,
  useCompteUpdateActeursJuridiquesMutation,
  useUpdateCompteModulesMutation,
} = compteApi;
